/* eslint-disable jsx-a11y/anchor-is-valid */
import {t} from "@lingui/core/macro";
import classNames from "classnames";
import * as React from "react";

import AphroditeCSSTransitionGroup from "#shared-styles-package/aphrodite-css-transition-group.tsx";
import {createTransition} from "#shared-styles-package/util.ts";

import {AVATAR_TRANSITION_DURATION_MS} from "./avatar-customizer.tsx";
import AvatarDrawer from "./avatar-drawer.tsx";
import type {
    AvatarModel,
    AvatarPart,
    AvatarPartType,
    AvatarsAnimation,
} from "./types.ts";

type Props = {
    animation: AvatarsAnimation;
    // Styles applicable to the currently selected model.
    modelStyles: Array<AvatarPart>;
    onPartTypeClick: (arg1: AvatarPartType) => void;
    onPartClick: (arg1: string) => void;
    selectedPart: string;
    selectedModel?: AvatarModel;
    visible: boolean;
};

export default class AvatarPartsAccordion extends React.Component<Props> {
    render(): React.ReactNode {
        let accordionDrawerClasses = classNames({
            "accordion-drawer": true,
            "fancy-scrollbar": true,
            opened: true,
        });
        accordionDrawerClasses += ` style-parts ${this.props.animation}`;

        const drawers = [
            <li key="style">
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- TODO: Address a11y error */}
                <a
                    className="part-type-heading"
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={this.props.onPartTypeClick.bind(null, "style")}
                >
                    {t`Style`}
                </a>
                <div className={accordionDrawerClasses}>
                    <AphroditeCSSTransitionGroup
                        transitionEnterTimeout={AVATAR_TRANSITION_DURATION_MS}
                        transitionLeaveTimeout={AVATAR_TRANSITION_DURATION_MS}
                        transitionStyle={() => {
                            if (this.props.animation === "slide-left") {
                                return drawerSlideLeftTransition;
                            }
                            if (this.props.animation === "slide-right") {
                                return drawerSlideRightTransition;
                            }
                            return {};
                        }}
                    >
                        <AvatarDrawer
                            avatarPartType="style"
                            avatarParts={this.props.modelStyles}
                            onPartClick={this.props.onPartClick}
                            selectedPart={this.props.selectedPart}
                            selectedModel={this.props.selectedModel}
                            showPartName={false}
                            visible={this.props.visible}
                        />
                    </AphroditeCSSTransitionGroup>
                </div>
            </li>,
        ];

        return <ul className="avatar-parts-accordion">{drawers}</ul>;
    }
}

const drawerSlideRightTransition = createTransition({
    enter: {
        left: -140,
    },
    enterActive: {
        left: 0,
    },
    leave: {
        left: 0,
    },
    leaveActive: {
        left: 140,
    },
});

const drawerSlideLeftTransition = createTransition({
    enter: {
        left: 140,
    },
    enterActive: {
        left: 0,
    },
    leave: {
        left: 0,
    },
    leaveActive: {
        left: -140,
    },
});
